import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import StNavbar from '../../components/StNavbar';
import StFooter from '../../components/StFooter';
import { SetSeo } from '../../lib/common_funcs';

import '../../redesign-2025.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { DocsConfig, DocsCategories, DocsHomeConfig } from './DocsConfig';

function StDocsHome() {
    useEffect(() => {
        AOS.init({
            duration: 800,
            once: true,
            easing: 'ease-out-cubic',
            offset: 50
        });
    }, []);

    const allParams = {
        "seo": DocsHomeConfig.seo,
        "schema": DocsHomeConfig.schema
    };

    // Group docs by category
    const docsArray = Object.values(DocsConfig);
    const sortedCategories = [...DocsCategories].sort((a, b) => a.order - b.order);

    const getDocsByCategory = (categoryName) => {
        return docsArray
            .filter(doc => doc.category === categoryName)
            .sort((a, b) => a.order - b.order);
    };

    return (
        <div className="ts-redesign">
            <SetSeo {...allParams} />
            <StNavbar />

            {/* Hero Section */}
            <header className="ts-hero" style={{minHeight: 'auto', paddingBottom: '4rem'}}>
                <div className="ts-hero-bg">
                    <div className="ts-gradient-orb ts-orb-1"></div>
                    <div className="ts-gradient-orb ts-orb-2"></div>
                    <div className="ts-gradient-orb ts-orb-3"></div>
                </div>
                <div className="ts-grid-pattern"></div>

                <div className="container ts-hero-content">
                    <div className="text-center" data-aos="fade-up">
                        <h1 className="ts-hero-title">
                            <span className="ts-gradient-text">{DocsHomeConfig.title}</span>
                        </h1>
                        <p className="ts-hero-subtitle" style={{maxWidth: '600px', margin: '1rem auto 0'}}>
                            {DocsHomeConfig.subtitle}
                        </p>
                    </div>
                </div>
            </header>

            <main className="main-content">
                <section className="ts-section ts-section-light">
                    <div className="container">
                        {sortedCategories.map((category, catIndex) => {
                            const categoryDocs = getDocsByCategory(category.name);
                            if (categoryDocs.length === 0) return null;

                            return (
                                <div key={category.name} className="ts-docs-category" data-aos="fade-up" data-aos-delay={catIndex * 50}>
                                    <h2 className="ts-docs-category-title">{category.name}</h2>
                                    <p className="ts-docs-category-desc">{category.description}</p>

                                    <div className="ts-docs-grid">
                                        {categoryDocs.map((doc, index) => (
                                            <div key={doc.slug} className="ts-docs-card">
                                                <div className="ts-docs-card-icon">
                                                    <i className={doc.icon}></i>
                                                </div>
                                                <div className="ts-docs-card-content">
                                                    <h3>{doc.name}</h3>
                                                    <p>{doc.description}</p>
                                                    {doc.external ? (
                                                        <a
                                                            href={doc.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="ts-docs-link"
                                                        >
                                                            View Documentation
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                                                                <polyline points="15 3 21 3 21 9"/>
                                                                <line x1="10" y1="14" x2="21" y2="3"/>
                                                            </svg>
                                                        </a>
                                                    ) : (
                                                        <Link to={`/docs/${doc.slug}`} className="ts-docs-link">
                                                            Read Guide
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <path d="M5 12h14M12 5l7 7-7 7"/>
                                                            </svg>
                                                        </Link>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        })}

                        <div className="text-center mt-5" data-aos="fade-up">
                            <p style={{color: 'var(--ts-gray)'}}>
                                Need help? <a href="/contactus">Contact us</a> or visit our <a href="https://turbosteed.freshdesk.com/support/home" target="_blank" rel="noopener noreferrer">Help Center</a>
                            </p>
                        </div>
                    </div>
                </section>
            </main>

            <StFooter />
        </div>
    );
}

export default StDocsHome;
